import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type PaymentRequestState = CommonTableState;

const initialState: PaymentRequestState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            created: false,
            modified: false,
        },
        columnOrder: [
            "mrt-row-expand",
            "created",
            "variableSymbol",
            "amount",
            "dueDate",
            "state",
            "externalTransactionTime",
            "periodStart",
            "periodEnd",
            "graceDueDate",
            "description",
            "accountType",
            "issuerId",
            "type",
            "targetId",
            "gatewayType",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const paymentRequestSlice = createSlice({
    name: "paymentRequest",
    initialState: initialState,
    reducers: {
        updatePaymentRequestTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updatePaymentRequestTableState } = paymentRequestSlice.actions;

export default paymentRequestSlice.reducer;
